import { Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../Provider'
import { Toast } from '../OPcomponents/Toast'
import RoleTable from './myroles/RoleTable'
import './myskills.scss'

const MyRoles = (): JSX.Element => {
  const { t } = useTranslation()
  const rootStore = useStore()
  const { validatedUser } = rootStore.loginStore
  const { getAllUserRoles } = rootStore.personStore

  useEffect(() => {
    getAllUserRoles(validatedUser)
  }, [getAllUserRoles, validatedUser])

  return (
    <Grid container rowGap={4}>
      <Toast />
      <Grid container item direction='row' justifyContent='space-between' alignItems='center'>
        <Grid item>
          <p className='profile--titlebigfont'>{t('Roles.MyRoles')}</p>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <RoleTable />
      </Grid>
    </Grid>
  )
}

export default observer(MyRoles)
